import { FC } from 'react';

export type BoldIconProps = {};

export const BoldIcon: FC<BoldIconProps> = ({}) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 7.99996H9.33333C10.8061 7.99996 12 6.80605 12 5.33329C12 3.86053 10.8061 2.66663 9.33333 2.66663H4V7.99996ZM4 7.99996H10C11.4728 7.99996 12.6667 9.19387 12.6667 10.6666C12.6667 12.1394 11.4728 13.3333 10 13.3333H4V7.99996Z"
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
